module.exports = __webpack_public_path__ + "media/images/riders/small/MARIANA_SALAZAR-8bbc1b34b7866175ba72bb0113053da4.png";